import React from 'react'
import { Container,Row,Col, Carousel} from 'react-bootstrap'
import './skills.css'
import { Zoom } from 'react-awesome-reveal'
import {motion} from 'framer-motion'
import { skillsInfo } from './skillsInfo.js'


const Skill = (props) => {
  // console.log(props.item.name);
  return (
      <div
        key={props.item.key}
        className='border skillBox center'
      >
        <img src={props.item.img} alt="skillImg" className='skillImg' width={100} height={100} />
        {/* <h4 className='text-center'>{props.item.name}</h4> */}
      </div>
  )
}

const SkillContainer = () => {
  
  return (
      <div className='skillContainer'>
        <Row className='center'>
          <Col className='center skillHeading '>
            <motion.h1
              initial={
                {scale:0}
              }
              animate={{scale:2}}
              transition={{duration:'0.6s',  delay:'2s'}}
            >What I am Good At</motion.h1>
          </Col>
        </Row>
        <Carousel>
          {
            skillsInfo.map((skillset) => 
              <Carousel.Item className='carousel-item-customized'>
                <Container className='skillArea'>
                  <div className='center' style={{width:'80%', flexWrap:'wrap',margin:'auto'}}>
                    {skillset.map((skill) =>
                      <Skill item={skill} />                        
                    )}
                  </div>
                 </Container>
              </Carousel.Item>
            )
          }
        </Carousel>
      </div>
  )
}

function Skills() {
  return (
    <Container fluid className='skillsSection'>
      <Zoom>
        <SkillContainer />
      </Zoom>
    </Container>
  )
}

export default Skills